document.addEventListener('DOMContentLoaded', function () {
  const productForm = document.querySelector('.product-form');

  if (!productForm) {
    return;
  }

  const breakpoint = 750;
  const targetClass = 'below-view';

  let observer;

  const handleIntersect = (entries) => {
    const targetElement = document.querySelector('.product-form');
    entries.forEach((entry) => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        targetElement.classList.add(targetClass);
      } else {
        targetElement.classList.remove(targetClass);
      }
    });
  };

  const setupObserver = () => {
    const sentinelElement = document.createElement('div');
    sentinelElement.classList.add('sentinel-element');
    sentinelElement.style.display = 'block';
    productForm.insertAdjacentElement('afterend', sentinelElement);

    observer = new IntersectionObserver(handleIntersect, {
      threshold: 0,
    });
    observer.observe(sentinelElement);
  };

  const cleanupObserver = () => {
    if (observer) {
      observer.disconnect();
      observer = null;
      const sentinelElement = document.querySelector('.sentinel-element');
      if (sentinelElement) {
        sentinelElement.remove();
      }
    }
  };

  const handleMediaChange = (e) => {
    if (e.matches) {
      setupObserver();
    } else {
      cleanupObserver();
    }
  };

  const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);
  mediaQuery.addEventListener('change', handleMediaChange);

  if (mediaQuery.matches) {
    setupObserver();
  }
});
